<template>
  <div>
    <iframe :src="qzUrl" width="100%" height="100%" frameborder="no"></iframe>
  </div>
</template>

<script>
export default {
  name: "qZ",
  components: {},
  data() {
    return {
      qzUrl: "",
    };
  },
  methods: {},
  mounted() {
    window.addEventListener(
      "message",
      function (event) {
        if (event.data.saveSign) {
          //签章完成保存签章
          window.close();
        }
      }.bind(this)
    );
    const search = decodeURIComponent(window.location.search).substring(1);
    const obj = {};
    search.split("&").forEach((pair) => {
      var keyValue = pair.split("=");
      obj[keyValue[0]] = keyValue[1];
    });
    if (Number(obj.type) === -1) {
      this.$message.error("ca锁已作废，请联系招天下客服进行处理！");
    } else if (Number(obj.type) === -2) {
      this.$message.error("ca锁未与账号绑定，请绑定后在进行签章操作！");
    } else if (Number(obj.type) === -3) {
      this.$message.error("ca锁已过期，请延期后在进行签章操作！");
    }
    let defaultUrl = ''
    if (process.env.VUE_APP_NODE === 'development') {
      defaultUrl = 'https://tca.zhaotx.cn/lxSign'
    } else {
      defaultUrl = 'https://ca.zhaotx.cn/lxSign'
    }
    if (obj.url) {
      defaultUrl = obj.url
    }
    this.qzUrl = `${defaultUrl}?${search}`;
  },
  beforeDestroy() {},
};
</script>

<style scoped></style>
